import { render, staticRenderFns } from "./athena.vue?vue&type=template&id=6104c71e&"
import script from "./athena.vue?vue&type=script&lang=js&"
export * from "./athena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports